import { useState } from 'react';
import { useLocation } from 'react-router-dom';

// Signing out on a page is not a return to it; an expired session remembers its page in BackendClient
export function useArrivalReturnPath(signedIn: boolean): string | null {
  const location = useLocation();
  const [wasSignedIn, setWasSignedIn] = useState(signedIn);
  if (signedIn && !wasSignedIn) setWasSignedIn(true);
  return signedIn || wasSignedIn ? null : location.pathname + location.search + location.hash;
}
